export const createCourseTemplate = (courseCards, landingPageData) => {
  if (landingPageData) {
    return `
      <div class="course-container">
        <div class="course-inner-container">
          <div class="course-sections-container">
            ${courseCards
              .map(
                section => `
              <div class="course-section">
                <div class="section-header">
                  <div class="section-title">
                    ${section.name}
                  </div>
                </div>
                
                <div class="section-divider-container">
                  <hr class="section-divider" />
                </div>
                
                <div class="cards-container">
                  ${section.cards
                    .map(
                      card => `
                    <div class="card-item">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="rgba(145, 158, 171, 0.32)"/>
                      </svg>
                      <div class="card-title">
                        ${card.title || 'Untitled Card'}
                      </div>
                    </div>
                  `,
                    )
                    .join('')}
                </div>
              </div>
            `,
              )
              .join('')}
          </div>
          
          <div class="start-button-container">
            <div class="start-button" style="background: ${
              landingPageData.primaryColor
            } !important; font-family: ${landingPageData.font} !important"">
              <div class="start-button-text">
                ${
                  landingPageData.localizations
                    ? landingPageData.localizations.startButton
                    : 'START COURSE'
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }
}
